import { DividerHairline } from './component.styles'
export default DividerHairline
